import { ReactElement, useState } from "react";
import { DealmakerCard as DealmakerCardModel, getFirmArchivedDeals } from "../../../Services/DealmakerCatalog";
import { moreDealsLabel } from "../dealmakerDisplay";
import DealmakerCard from "./DealmakerCard";
import DealmakerPager from "./DealmakerPager";

interface DealmakerArchivedProps {
  items: DealmakerCardModel[];
  page: number;
  pageCount: number;
}

export default function DealmakerArchived({ items, page, pageCount }: DealmakerArchivedProps): ReactElement | null {
  const [openFirmId, setOpenFirmId] = useState<number | null>(null);
  const [extra, setExtra] = useState<DealmakerCardModel[]>([]);
  if (items.length === 0) {
    return null;
  }

  async function toggle(card: DealmakerCardModel): Promise<void> {
    if (openFirmId === card.firmId) {
      setOpenFirmId(null);
      setExtra([]);
      return;
    }
    const rows = await getFirmArchivedDeals(String(card.firmId), String(card.dealId));
    setExtra(rows);
    setOpenFirmId(card.firmId);
  }

  return (
    <section className="mt-8">
      <div className="dealmaker-toolbar">
        <h3 className="dealmaker-archived-title">Archived Deals</h3>
        <DealmakerPager page={page} pageCount={pageCount} pageKey="archivedPage" />
      </div>
      {items.map((card) => (
        <div key={card.firmId}>
          <DealmakerCard card={card} archived />
          {card.dealCount > 1 ? (
            <div className="text-right">
              <button type="button" className="dealmaker-overview-link" onClick={() => { void toggle(card); }}>
                {openFirmId === card.firmId ? `LESS ${card.companyName} DEALS` : moreDealsLabel(card.companyName)}
              </button>
            </div>
          ) : null}
          {openFirmId === card.firmId ? extra.map((row) => <DealmakerCard key={row.dealId} card={row} archived />) : null}
        </div>
      ))}
      <DealmakerPager page={page} pageCount={pageCount} pageKey="archivedPage" />
    </section>
  );
}
